// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  GenericApiResponse,
  GetAllJobsParams,
  GetJobStatusParams,
  HTTPValidationError,
  RunJobInEngineBody,
} from '../../models';

/**
 * submit a job to the background task queue
 * @summary Run Job In Engine
 */
export const runJobInEngine = (
  runJobInEngineBody: RunJobInEngineBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponse>> => {
  return axios.post(`/jobs/run`, runJobInEngineBody, options);
};

export const getRunJobInEngineMutationOptions = <
  TData = Awaited<ReturnType<typeof runJobInEngine>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: RunJobInEngineBody }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['runJobInEngine'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof runJobInEngine>>, { data: RunJobInEngineBody }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return runJobInEngine(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: RunJobInEngineBody },
    TContext
  >;
};

export type RunJobInEngineMutationResult = NonNullable<Awaited<ReturnType<typeof runJobInEngine>>>;
export type RunJobInEngineMutationBody = RunJobInEngineBody;
export type RunJobInEngineMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Run Job In Engine
 */
export const useRunJobInEngine = <
  TData = Awaited<ReturnType<typeof runJobInEngine>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: RunJobInEngineBody }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { data: RunJobInEngineBody }, TContext> => {
  const mutationOptions = getRunJobInEngineMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * submit a job to the background task queue
 * @summary Get Job Status
 */
export const getJobStatus = (
  jobId: string | null,
  params?: GetJobStatusParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponse>> => {
  return axios.get(`/jobs/${jobId}`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetJobStatusQueryKey = (jobId: string | null, params?: GetJobStatusParams) => {
  return [`/jobs/${jobId}`, ...(params ? [params] : [])] as const;
};

export const getGetJobStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobStatus>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  jobId: string | null,
  params?: GetJobStatusParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobStatus>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobStatusQueryKey(jobId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobStatus>>> = ({ signal }) =>
    getJobStatus(jobId, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!jobId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetJobStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getJobStatus>>>;
export type GetJobStatusQueryError = AxiosError<void | HTTPValidationError>;

export function useGetJobStatus<
  TData = Awaited<ReturnType<typeof getJobStatus>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  jobId: string | null,
  params: undefined | GetJobStatusParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobStatus>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getJobStatus>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetJobStatus<
  TData = Awaited<ReturnType<typeof getJobStatus>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  jobId: string | null,
  params?: GetJobStatusParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobStatus>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getJobStatus>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetJobStatus<
  TData = Awaited<ReturnType<typeof getJobStatus>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  jobId: string | null,
  params?: GetJobStatusParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobStatus>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Job Status
 */

export function useGetJobStatus<
  TData = Awaited<ReturnType<typeof getJobStatus>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  jobId: string | null,
  params?: GetJobStatusParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobStatus>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetJobStatusQueryOptions(jobId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * submit a job to the background task queue
 * @summary Get Job Status
 */
export const getAllJobs = (
  params?: GetAllJobsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponse>> => {
  return axios.get(`/jobs`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetAllJobsQueryKey = (params?: GetAllJobsParams) => {
  return [`/jobs`, ...(params ? [params] : [])] as const;
};

export const getGetAllJobsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllJobs>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetAllJobsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllJobs>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllJobsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllJobs>>> = ({ signal }) =>
    getAllJobs(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllJobs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllJobsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllJobs>>>;
export type GetAllJobsQueryError = AxiosError<void | HTTPValidationError>;

export function useGetAllJobs<
  TData = Awaited<ReturnType<typeof getAllJobs>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params: undefined | GetAllJobsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllJobs>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getAllJobs>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllJobs<
  TData = Awaited<ReturnType<typeof getAllJobs>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetAllJobsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllJobs>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getAllJobs>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllJobs<
  TData = Awaited<ReturnType<typeof getAllJobs>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetAllJobsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllJobs>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Job Status
 */

export function useGetAllJobs<
  TData = Awaited<ReturnType<typeof getAllJobs>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetAllJobsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllJobs>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAllJobsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Stream job status updates to the client with SSE
 * @summary Stream Job Status
 */
export const streamJobStatus = (jobId: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> => {
  return axios.get(`/jobs/${jobId}/stream`, options);
};

export const getStreamJobStatusQueryKey = (jobId: string) => {
  return [`/jobs/${jobId}/stream`] as const;
};

export const getStreamJobStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof streamJobStatus>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  jobId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamJobStatus>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getStreamJobStatusQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof streamJobStatus>>> = ({ signal }) =>
    streamJobStatus(jobId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!jobId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof streamJobStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type StreamJobStatusQueryResult = NonNullable<Awaited<ReturnType<typeof streamJobStatus>>>;
export type StreamJobStatusQueryError = AxiosError<void | HTTPValidationError>;

export function useStreamJobStatus<
  TData = Awaited<ReturnType<typeof streamJobStatus>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  jobId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamJobStatus>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof streamJobStatus>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useStreamJobStatus<
  TData = Awaited<ReturnType<typeof streamJobStatus>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  jobId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamJobStatus>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof streamJobStatus>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useStreamJobStatus<
  TData = Awaited<ReturnType<typeof streamJobStatus>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  jobId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamJobStatus>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Stream Job Status
 */

export function useStreamJobStatus<
  TData = Awaited<ReturnType<typeof streamJobStatus>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  jobId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamJobStatus>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getStreamJobStatusQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
